<template>
  <div>
    <section class="orep-header mont" v-if="['group-appraiser-representation'].indexOf($route.name) < 0">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer'"  src="../../../public/assets/images/mercer-logo.png" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'Realshield'"  src="../../../public/assets/images/realshield-logo-blue.png" class="logo" alt="Logo">
        <img v-else  src="../../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "ibdpro-mga-application",
    computed: {
      mgaApplication() {
        return this.$store.state.mgaApplication.mgaApplication;
      },
      state() {
        return this.$store.state.mgaApplication;
      },
      errorMsg() {
        return this.$store.state.mgaApplication.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/ibdpro-mga-application-amba/' || this.mgaApplication.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/ibdpro-mga-application-realshield/' || this.mgaApplication.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
